<!-- Modal Title -->
<div *nzModalTitle class="font-600">
	{{ "global.common.rate_supplier" | translate }}
</div>

<div>
	<form [formGroup]="rateSupplierForm">

		<nz-form-item class="input-field title-14 ml-2 mr-2">
			<nz-form-control>
				<label>
					<div class="mb-3px">{{ "global.common.rating_modal.delivery_rating" | translate }}* : </div>
				</label>
				<nz-rate formControlName="deliveryRating" class="ratingDiv" [ngClass]="getRateClass(rateSupplierForm.value.deliveryRating)" [nzTooltips]="ratingStatuses" nzAllowHalf>
				</nz-rate>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item class="input-field title-14 ml-2 mr-2">
			<nz-form-control>
				<label>
					<div class="mb-3px">{{ "global.common.rating_modal.communication_rating" | translate }}* : </div>
				</label>
				<nz-rate formControlName="communicationRating" class="ratingDiv" [ngClass]="getRateClass(rateSupplierForm.value.communicationRating)" [nzTooltips]="ratingStatuses"
					nzAllowHalf>
				</nz-rate>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item class="input-field title-14 ml-2 mr-2">
			<nz-form-control>
				<label>
					<div class="mb-3px">{{ "global.common.rating_modal.overall_rating" | translate }}* : </div>
				</label>
				<nz-rate formControlName="overallRating" class="ratingDiv" [ngClass]="getRateClass(rateSupplierForm.value.overallRating)" [nzTooltips]="ratingStatuses" nzAllowHalf>
				</nz-rate>
			</nz-form-control>
		</nz-form-item>

		<nz-form-item class="input-field title-14 ml-2 mr-2">
			<nz-form-control>
				<label>
					<div class="mb-3px">{{ "global.common.rating_modal.review" | translate }} :</div>
				</label>
				<app-text-area-field [formName]="'description'" [form]="rateSupplierForm"
					[fieldSize]="{ minRows: 4, maxRows: 4 }"
					[placeholder]="'global.supplier.products.modals.placeholder.description' | translate">
				</app-text-area-field>
			</nz-form-control>
		</nz-form-item>

	</form>
</div>

<!-- Modal Footer -->
<div *nzModalFooter>
	<button nz-button nzType="default" [disabled]="rateSupplierForm.invalid"
	[ngClass] = "!rateSupplierForm.invalid ? 'bg-color-blue color-white border-radius-5' : 'border-radius-5' "  (click)="submitRating()">
		{{ "global.common.rating_modal.submit" | translate }}
	</button>
</div>
